module.exports = __webpack_public_path__ + "img/shopping-cart.7dff4055.svg";